export function changeOrder(arr, f, t) {
	let tmp = arr[f];
	arr.splice(f, 1, arr[t]);
	arr.splice(t, 1, tmp);
	return arr;
}

export default changeOrder;